/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetterTree, ActionTree, MutationTree } from 'vuex';
import { States, StatesState } from '@/store/interfaces/location';
// Set the types for the store modules
import locationType from '@/store/types/location';
import { http } from '@/util/HTTP';

const namespaced = true;

const initialState = (): StatesState => {
  return {
    statesList: [],
  };
};

const state: StatesState = initialState();

const getters: GetterTree<StatesState, any> = {
  [locationType.getters.GET_STATE]: state => {
    return state.statesList;
  },
};
const mutations: MutationTree<StatesState> = {
  reset: (state: any) => {
    const initialStateFields: any = initialState();
    Object.keys(initialStateFields).forEach((key: any) => {
      state[key] = initialStateFields[key];
    });
  },

  [locationType.mutations.SET_STATE]: (
    state,
    states: Array<States>
  ) => {
    const statesList: Array<States> = states;

    state.statesList = statesList;
  },
};
const actions: ActionTree<StatesState, any> = {
  [locationType.actions.STATE_LIST]: ({ commit, }, country_code) => {
    return new Promise((resolve, reject) => {
      http
        .get(`resources/countries/${country_code}/states`)
        .then(res => {
          if (res.status === 200) {
            commit(locationType.mutations.SET_STATE, res.data);
          }
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        })
        .finally(() => {

        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
